module.exports = __webpack_public_path__ + "img/Eat-Us-Alive-cover-smaller.9052700a.jpg";